export default function getAvailableRegisters(registers = []) {
  return registers.filter(register => !register.connected)
}
